// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2N5ci","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__YWYps"};